import React from 'react'
import styled from 'styled-components'
import {Delete} from '@mui/icons-material'
import ColorPicker from 'components/ColorPicker'

const Container = styled.div`
    box-sizing: border-box;
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;

    > svg {
        font-size: 25px;
        margin-left: 100px;
        padding-left: 10px;
        color: #d45b4a;
        cursor: pointer;
    }
`

const Label = styled.span`
    font-weight: 700;
    margin-right: auto;

    :not(:first-child) {
        margin: 0 10px;
    }
`

class Item extends React.PureComponent {
    handleChange = (color) => {
        this.props.handleChange(this.props.value, color.hex, this.props.fieldId)
    }

    render() {
        return (
            <Container>
                <Label>{this.props.title}</Label>
                <ColorPicker
                    type='swatches'
                    color={this.props.color}
                    handleChange={this.handleChange}
                />
                <Delete onClick={() => this.props.handleDelete(this.props.value)} />
            </Container>
        )
    }
}

export default Item
